var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 34,
    viewBox: "0 0 23 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5205 14.1122V2.63857L7.56623 9.52454L8.88602 12.1631L18.5344 7.42323L18.5434 7.41129V25.6515C17.8413 26.6783 15.6839 29.475 11.4985 30.8898C7.31311 29.478 5.15564 26.6783 4.45356 25.6515V8.02318L15.4308 2.63857L14.111 0L1.4795 6.19946V14.1122H0V21.9682H1.4795V26.4335C4.61326 32.2031 11.4985 34 11.4985 34C11.4985 34 18.3867 32.2031 21.5175 26.4335V21.9682H22.997V14.1122H21.5175H21.5205ZM9.06983 15.6255H6.09577V18.5715H9.06983V15.6255ZM12.987 22.992H10.013V25.938H12.987V22.992ZM13.9302 15.6255V18.5715H16.9042V15.6255H13.9302Z",
    fill: "#0087FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_1249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.3b199376a0d09f2bc6af27cdb1cf698f.svg";
export { ForwardRef as ReactComponent };